import { combineReducers } from 'redux';
import types from './types';
import SubcategoryModel from 'src/model/subcategory.model';
import CategoryModel from 'src/model/category.model';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';
import ProductModel from 'src/model/product.model';

const categories = (
  state: CategoryModel[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: CategoryModel[];
  }
) => {
  switch (type) {
    case types.SET_CATEGORIES:
      return payload;

    default:
      return state;
  }
};

const getCategoriesIsPending = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
): boolean => {
  switch (type) {
    case types.CATEGORIES_PENDING:
      return payload;
    default:
      return state;
  }
};

const getSubcategoriesIsPending = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SUBCATEGORIES_PENDING:
      return payload;

    default:
      return state;
  }
};

const getSubcategoriesFilterIsPending = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SUBCATEGORIES_FILTERS_PENDING:
      return payload;

    default:
      return state;
  }
};

const getProductsIsPending = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.PRODUCTS_PENDING:
      return payload;

    default:
      return state;
  }
};

const getFilteredProductsIsPending = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.FILTERED_PRODUCTS_PENDING:
      return payload;

    default:
      return state;
  }
};

const categoriesProducts = (
  state: any[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any[];
  }
): any[] => {
  switch (type) {
    case types.SET_PRODUCTS:
      return payload;

    default:
      return state;
  }
};

const activeSubcategory = (
  state: number = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: number;
  }
) => {
  switch (type) {
    case types.SET_ACTIVE_SUBCATEGORY:
      return payload;

    default:
      return state;
  }
};

const subcategories = (
  state: SubcategoryModel[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: SubcategoryModel[];
  }
) => {
  switch (type) {
    case types.SET_SUBCATEGORIES:
      return payload;

    default:
      return state;
  }
};

const categoriesFilters = (
  state: SubcategoryFilter[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any[];
  }
): any[] => {
  switch (type) {
    case types.SET_CATEGORIES_FILTERS:
      return payload;

    default:
      return state;
  }
};

const activeFilters = (
  state: SubcategoryFilter[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: SubcategoryFilter[] | [];
  }
): any => {
  switch (type) {
    case types.SET_ACTIVE_FILTERS:
      return payload;

    default:
      return state;
  }
};

const filteredProducts = (
  state: ProductModel[] = [],
  {
    type,
    payload
  }: {
    type: string;
    payload: ProductModel[];
  }
): any => {
  switch (type) {
    case types.SET_FILTERED_PRODUCTS:
      return payload;

    default:
      return state;
  }
};

const categoriesError = (
  state: any = {
    hasFailed: false,
    error: ''
  },
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.CATEGORIES_ERROR:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  categories,
  getCategoriesIsPending,
  getSubcategoriesIsPending,
  getProductsIsPending,
  getSubcategoriesFilterIsPending,
  getFilteredProductsIsPending,
  products: categoriesProducts,
  filters: categoriesFilters,
  error: categoriesError,
  activeSubcategory,
  activeFilters,
  filteredProducts,
  subcategories
});
